import React from 'react';
import debugFactory from 'debug';

import { useIpc } from '~src/main/utils/ipc-utils';

const debug = debugFactory('ingrid:fullscreen');

/*
 * Count the number of fullscreen components that are open. In normal operation
 * there will be just one fullscreen component, but in edge case, which is
 * difficult to prevent, there could be more.
 */
let fullscreenRefCount = 0;

export function useFullscreenIframeController() {
  const lastFocusedElementRef = React.useRef<HTMLElement>();
  const ipc = useIpc();

  React.useEffect(() => {
    debug('open fullscreen');

    if (fullscreenRefCount === 0) {
      /*
       * Remember last focused element to restore focus after we close the
       * fullscreen iframe.
       */
      if (document.activeElement instanceof HTMLElement) {
        lastFocusedElementRef.current = document.activeElement;
      }

      ipc.send({
        name: 'fullscreen_modal_show',
      });
    }

    fullscreenRefCount++;

    return () => {
      debug('close fullscreen');

      fullscreenRefCount--;

      if (fullscreenRefCount === 0) {
        if (lastFocusedElementRef.current) {
          lastFocusedElementRef.current.focus();
        }

        ipc.send({
          name: 'fullscreen_modal_hide',
        });
      }
    };
  }, []);
}
